<template>
  <!-- 敏感信息解密组件 -->
  <div>
    <div class="mobile">
      <span v-if="showEye">{{ data[keyName + 'show'] }}</span>
      <span v-else>{{ data[keyName] }}</span>
      <span v-if="data[keyName]">
        <i class="iconfont iconxianshi eye-icon eye" v-if="showEye" @click="openEye()"></i>
        <i class="iconfont iconyincang eye-icon eye" v-else @click="openEye()"></i>
      </span>
    </div>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  props: {
    data: null,
    dataType: null,
    fun: null,
    queryKey: {
      default: 'id'
    },
    keyName: null
  },
  data() {
    return {
      showEye: false
    };
  },
  methods: {
    openEye() {
      if (!this.showEye) {
        this.descrypt(
          {
            query: this.data[this.queryKey],
            operationFunction: this.fun,
            operationType: this.dataType
          },
          this.data,
          this.keyName + 'show'
        ).then(() => {
          this.showEye = true;
        });
      } else {
        this.showEye = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.mobile {
  display: flex;
}
</style>